import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CartCheckboxAlt from '../CartCheckboxAlt/CartCheckboxAlt';

import { StyledTextArea } from '../CartGiftMessage/CartGiftMessageStyles';

var CartGiftMessageAlt = function CartGiftMessageAlt(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(props.checkoutNote || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  useEffect(function () {
    if (props.checkoutNote) {
      setInput(props.checkoutNote);
      setActive(true);
    }
  }, [props.checkoutNote]);

  var handleCheckboxChange = function handleCheckboxChange() {
    if (active === true && input != null) {
      localStorage.removeItem('dormify_checkout_note');
      setInput('');
    }
    setActive(!active);
  };

  var handleInputChange = function handleInputChange(event) {
    setInput(event.target.value);
  };

  return React.createElement(
    CartCheckboxAlt,
    {
      text: 'Add Gift Message',
      checked: active,
      onChange: handleCheckboxChange,
      maxHeight: '100px'
    },
    React.createElement(StyledTextArea, {
      name: 'note',
      placeholder: 'Type your message here. It will be added to the packing slip.',
      'aria-label': 'Gift message input',
      value: input,
      onChange: handleInputChange,
      onBlur: function onBlur() {
        return props.addCheckoutNote(input);
      }
    })
  );
};

CartGiftMessageAlt.propTypes = {
  addCheckoutNote: PropTypes.func.isRequired,
  checkoutNote: PropTypes.string
};

export default CartGiftMessageAlt;